export enum ArticleDependencyMode {
  IGNORE_ARTICLE = 'ignore_article',
  IGNORE_DEPENDENCY_ONLY = 'ignore_dependency_only',
}
